<script>
import PopinTraiteurPermanent from "@/components/organisms/popin-traiteur-permanent";
export default {
  components: { PopinTraiteurPermanent },
  emits: ["closed"],
  computed: {
    traiteurPermanentCategorySlug() {
      return useRuntimeConfig().public.TRAITEUR_PERMANENT_CATEGORY_SLUG;
    }
  }
};
</script>

<template>
  <PopinTraiteurPermanent
    :traiteur-permanent-category-slug="traiteurPermanentCategorySlug"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    @closed="$emit('closed')"
  />
</template>
